<template>
  <div>
    <div class="info-area">
      <div class="area-title-wrapper">
        <h3 class="area-title">低速无人驾驶车辆（装备）信息</h3>
      </div>
      
      <!-- 车辆表单 -->
      <div v-if="vehicleData" class="vehicle-form">
        <div class="form-row">
          <div class="form-item">
            <label class="form-label">车辆识别代码 <span class="required">*</span></label>
            <div class="form-input-wrapper">
              <a-input v-model:value="vehicleData.vin" placeholder="请输入车辆识别代码" class="form-input" :disabled="props.isSelected" />
              <a-button @click="handleAction" class="select-btn">{{ props.isSelected ? '重新录入' : '选择车辆' }}</a-button>
            </div>
          </div>
        </div>
        
        <div class="form-row">
          <div class="form-item">
            <label class="form-label">车辆型号 <span class="required">*</span></label>
            <div class="form-input-wrapper">
              <a-input v-model:value="vehicleData.model" placeholder="请输入车辆型号" class="form-input" :disabled="props.isSelected" />
            </div>
          </div>
        </div>
        
        <div class="form-row">
          <div class="form-item">
            <label class="form-label">类型 <span class="required">*</span></label>
            <div class="form-input-wrapper">
              <a-select v-model:value="vehicleData.type" placeholder="请选择类型" class="form-input" :disabled="props.isSelected">
                <a-select-option v-for="option in testVehicleTypeList" :key="option.id" :value="option.id">
                  {{ option.name }}
                </a-select-option>
              </a-select>
            </div>
          </div>
        </div>
        
        <div class="form-row">
          <div class="form-item">
            <label class="form-label">生产企业 <span class="required">*</span></label>
            <div class="form-input-wrapper">
              <a-input v-model:value="vehicleData.manufacturer" placeholder="请输入生产企业" class="form-input" :disabled="props.isSelected" />
            </div>
          </div>
        </div>
        
        <div class="form-row">
          <div class="form-item">
            <label class="form-label">生产日期 <span class="required">*</span></label>
            <div class="form-input-wrapper">
              <a-date-picker v-model:value="vehicleData.productionDate" placeholder="请选择生产日期" format="YYYY-MM-DD" value-format="YYYY-MM-DD" class="form-input" :disabled="props.isSelected" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Button, Select, DatePicker, Input } from 'ant-design-vue';

const props = defineProps({
  testVehicleTypeList: {
    type: Array,
    default: () => []
  },
  vehicleData: {
    type: Object,
    default: () => ({
      id: null,
      vin: '',
      model: '',
      type: '',
      manufacturer: '',
      productionDate: ''
    })
  },
  isSelected: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['select-vehicle', 'reset-vehicle']);

const handleAction = () => {
  if (props.isSelected) {
    emit('reset-vehicle');
  } else {
    emit('select-vehicle');
  }
};
</script>

<style scoped lang="less">
.info-area {
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  background-color: #ffffff;
}

.area-title-wrapper {
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #d9d9d9;
}

.area-title {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.vehicle-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-row {
  display: flex;
  gap: 24px;
  justify-content: center;
}

.form-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-width: 400px;
  width: 100%;
  max-width: 500px;
}

.form-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
  text-align: right;
  flex-shrink: 0;
  width: 100px;
  
  .required {
    color: #f5222d;
    margin-left: 4px;
  }
}

.form-input-wrapper {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
  width: 350px;
  justify-content: flex-start;
}

.form-input {
  width: 100%;
}

.select-btn {
  flex-shrink: 0;
}

:deep(.ant-input),
:deep(.ant-select-selector),
:deep(.ant-picker) {
  width: 100%;
  text-align: left;
}
</style>